import { render, staticRenderFns } from "./LoaderBalls.vue?vue&type=template&id=474912b8"
import script from "./LoaderBalls.vue?vue&type=script&lang=js"
export * from "./LoaderBalls.vue?vue&type=script&lang=js"
import style0 from "./LoaderBalls.vue?vue&type=style&index=0&id=474912b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports